import React, { useState } from 'react';

const IconAd2 = ({ size = 16, stroke = 2, color = "currentColor", hoverColor = "#1890ff", marginRight = 8 }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke={isHovered ? hoverColor : color}
            strokeWidth={stroke}
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{
                transition: "stroke 0.5s ease",
                marginRight: `${marginRight}px`, // Espacio a la derecha
                marginBottom: "-4px"
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <path d="M11.933 5h-6.933v16h13v-8" />
            <path d="M14 17h-5" />
            <path d="M9 13h5v-4h-5z" />
            <path d="M15 5v-2" />
            <path d="M18 6l2 -2" />
            <path d="M19 9h2" />
        </svg>
    );
};

export default IconAd2;
